import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  text-align: center;
`;
